module.exports = __webpack_public_path__ + "static/media/dashboard-one-on-one-star-active-icon.04d80d02.svg";